import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from "classnames";
import Select from 'react-simpler-select'

import NumberInput from "./UI/NumberInput";
import FloatNumberInput from './UI/FloatNumberInput';

import { learnModePresetsMenu, learnModePresets } from "../constants/learnModePresets";
import tooltips from '../constants/tooltips.json'

import {
  setSensitivityPreset,
  setPresetGain,
  setCrosstalkThreshold,
  setGlobalThreshold,
} from "../actions";

class LearnModeSettings extends Component {
  render() {
    const {
      presetGain,
      deviceConnected,
      crosstalkThreshold,
      globalThreshold,
      sensitivityPreset,
      showTooltips,
      onSetSensitivityPreset,
      onPresetGainChange,
      onSetCrosstalkThreshold,
      onSetGlobalThreshold,
    } = this.props;
    
    return (
      <div className="learn-mode-settings">
        <h3>Settings</h3>
        <div
          className={classnames(
            "label-number-input",
            "learn-mode-setting",
            "global-sensitivity",
            {
              disabled: !deviceConnected,
            }
          )}
          data-tip={tooltips["editor-sensitivity"]}
          data-place="bottom"
          data-multiline="true"
          data-tip-disable={!showTooltips}
        >
          <label>Global Sensitivity</label>
          <FloatNumberInput
            label="global-sensitivity"
            min={0.3}
            max={1.99}
            step={0.01}
            precision={2}
            disabled={!deviceConnected}
            onChange={(gain) => {
              onPresetGainChange(gain);
            }}
            value={presetGain}
          />
        </div>
        <div
          className={classnames(
            "label-number-input",
            "learn-mode-setting",
            "global-threshold",
            {
              disabled: !deviceConnected,
            }
          )}
          data-tip={tooltips["editor-global-threshold"]}
          data-multiline="true"
          data-place="bottom"
          data-tip-disable={!showTooltips}
        >
          <label>Global Threshold</label>
          <FloatNumberInput
            label="globalThreshold"
            step={0.01}
            min={0.01}
            max={1.99}
            precision={2}
            disabled={!deviceConnected}
            onChange={(threshold) => {
              onSetGlobalThreshold(threshold);
            }}
            value={globalThreshold}
          />
        </div>
        <div
          className={classnames(
            "label-number-input",
            "learn-mode-setting",
            "crosstalk",
            {
              disabled: !deviceConnected,
            }
          )}
          data-tip={tooltips["editor-global-crosstalk"]}
          data-multiline="true"
          data-place="bottom"
          data-tip-disable={!showTooltips}
        >
          <label>Crosstalk Threshold</label>
          <NumberInput
            name="crosstalkThreshold"
            step={1}
            min={1}
            max={8}
            disabled={!deviceConnected}
            onChange={onSetCrosstalkThreshold}
            value={crosstalkThreshold}
          />
        </div>
        <div
          className={classnames(
            "learn-mode-setting",
            "preset-select",
            "crosstalk",
            {
              disabled: !deviceConnected,
            }
          )}
          data-tip={tooltips["editor-preset-select"]}
          data-multiline="true"
          data-place="bottom"
          data-tip-disable={!showTooltips}
        >
          <label>Sensitivity Presets</label>
          <Select
            name="sensitivitypresets"
            className={sensitivityPreset === '---' ? 'dirty' : ''}
            value={sensitivityPreset}
            options={learnModePresetsMenu}
            onChange={(id) => {
              // update sensitivity preset
              onSetSensitivityPreset(id);
              // ignore changing values if dirty
              if(id === '---') return
              // get the preset settings
              const { sensitivity, threshold, crosstalkThreshold } =
                learnModePresets.find((p) => p.name === id);

              // update values
              onPresetGainChange(sensitivity);
              onSetGlobalThreshold(threshold);
              onSetCrosstalkThreshold(crosstalkThreshold);
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    deviceConnected: state.device.connected,
    presetGain: state.currentPreset.gain,
    globalThreshold: state.device.globalThreshold,
    crosstalkThreshold: state.device.crosstalkThreshold,
    sensitivityPreset: state.editor.sensitivityPreset,
    showTooltips: state.editorPreferences.showTooltips,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    onSetSensitivityPreset: (value) => {
      dispatch(setSensitivityPreset(value))
    },
    onPresetGainChange: (value) => {
      dispatch(setPresetGain(value));
    },
    onSetCrosstalkThreshold: (value) => {
      dispatch(setCrosstalkThreshold(value));
    },
    onSetGlobalThreshold: (value) => {
      dispatch(setGlobalThreshold(value));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnModeSettings)
